import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationMap = () => {
  const bakeryLocation = {
    lat: 43.6532,
    lng: -79.5831,
    address: "123 Etobicoke Street, Toronto, ON M9C 1A1"
  };

  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-warm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="MapPin" size={20} color="var(--color-primary)" />
          </div>
          <h2 className="text-2xl font-serif font-semibold text-foreground">
            Find Us
          </h2>
        </div>
        <p className="text-muted-foreground">
          Located in the heart of Etobicoke, easily accessible with ample parking
        </p>
      </div>
      <div className="relative w-full h-96">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title="Montesanto Bakery Location"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${bakeryLocation?.lat},${bakeryLocation?.lng}&z=15&output=embed`}
          className="border-0"
        />
      </div>
      <div className="p-6 bg-muted/30">
        <div className="flex items-start gap-3">
          <Icon name="Navigation" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
          <div>
            <p className="font-medium text-foreground mb-1">Address</p>
            <p className="text-sm text-muted-foreground">{bakeryLocation?.address}</p>
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${bakeryLocation?.lat},${bakeryLocation?.lng}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-3 text-sm font-medium text-primary hover:text-primary/80 transition-colors"
            >
              Get Directions
              <Icon name="ExternalLink" size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationMap;